var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 15.25,
    r: 3.75,
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 7,
    r: 2,
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5974 11.4718C15.9372 10.4177 16.4617 8.63033 15.9039 7.01943C15.3462 5.40854 13.8288 4.32813 12.1241 4.32813C10.4194 4.32813 8.90196 5.40854 8.34422 7.01943C7.78648 8.63033 8.31098 10.4177 9.65075 11.4718C7.36881 12.386 5.77516 14.4819 5.50408 16.9251C5.46358 17.2933 5.72922 17.6246 6.09741 17.6651C6.4656 17.7056 6.79691 17.44 6.83741 17.0718C7.1405 14.3736 9.42227 12.3338 12.1374 12.3338C14.8526 12.3338 17.1343 14.3736 17.4374 17.0718C17.475 17.4111 17.7627 17.6672 18.1041 17.6651H18.1774C18.5412 17.6233 18.8031 17.2959 18.7641 16.9318C18.4917 14.4813 16.8891 12.3813 14.5974 11.4718ZM12.1198 10.9974C10.647 10.9974 9.45312 9.80349 9.45312 8.33073C9.45312 6.85797 10.647 5.66406 12.1198 5.66406C13.5925 5.66406 14.7865 6.85797 14.7865 8.33073C14.7865 9.03797 14.5055 9.71625 14.0054 10.2163C13.5053 10.7164 12.827 10.9974 12.1198 10.9974Z",
    fill: "#00212E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.866549d7285a722ee67836057cefe40f.svg";
export { ForwardRef as ReactComponent };